import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { MAP_MODES, MAP_TOOLS } from '../../../lib/constants';
import styles from './ElevationProfileWidget.module.scss';
import actions from './actions';
import ElevationIcon from '../../../assets/svg/ElevationIcon';
import ElevationProfile from '@arcgis/core/widgets/ElevationProfile';

function ElevationProfileWidget(props) {
  const [elevProfileWidget, setElevProfileWidget] = useState(null);

  useEffect(() => {
    /*
      #NOTE: Keeping this commented out in case there are now side-effects (haven't found any yet though)
      -- KD - July 22, 2020
    */
    if (props.view.ui.find('elevProf') != null) {
      return;
    }

    const elevProf = new ElevationProfile({
      id: 'elev-prof',
      view: props.view,
      unit: 'imperial',
      visibleElements: {
        selectButton: false,
      },
      profiles: [
        {
          type: 'ground',
          color: '#f37735',
          title: 'Ground Elevation',
        },
      ],
    });

    props.setElevProfWidgetRef(elevProf);
    setElevProfileWidget(elevProf);

    if (props.mapMode === MAP_MODES.ThreeD) {
      elevProf.view = props.view;
      if (props.activeTool === MAP_TOOLS.ElevationProfile) {
        props.view.ui.add(elevProf, { position: 'manual' });
        elevProf.viewModel.start();
      } else {
        props.view.ui.remove(elevProfileWidget);
      }
    } else if (props.mapMode === MAP_MODES.TwoD) {
      props.view.ui.remove(elevProfileWidget);
    }

    return () => {
      props.view.ui.remove(elevProfileWidget);
    };
  }, [props.mapMode, props.activeTool]);

  if (!props.isMapReady) return null;
  if (props.mapMode != MAP_MODES.ThreeD) return null;

  return (
    <button
      className={[
        'esri-widget--button',
        'esri-interactive',
        // 'esri-icon-measure-line',
        'esri-widget__button--selected',
        styles.measureButton,
        props.activeTool === MAP_TOOLS.ElevationProfile ? styles.selected : '',
      ].join(' ')}
      onClick={
        props.activeTool === MAP_TOOLS.ElevationProfile
          ? props.clearMeasurements
          : props.enableElevationProfile
      }
      title="Elevation Profile"
    >
      <ElevationIcon color={'#ffffff'} width={20} height={20} />
    </button>
  );
}

ElevationProfileWidget.propTypes = {
  view: PropTypes.any,
  map: PropTypes.any,
  mapMode: PropTypes.string,
  isMapReady: PropTypes.bool,
  activeTool: PropTypes.string,
  measureWidgetRef: PropTypes.any,
  isUpdatingLocation: PropTypes.bool,
  //actions
  enableElevationProfile: PropTypes.func,
  setElevProfWidgetRef: PropTypes.func,
  clearMeasurements: PropTypes.func,
};

export default connect((model) => {
  return {
    isMapReady: model.map.isMapReady,
    activeTool: model.map.activeTool,
    measureWidgetRef: model.map.widgetRefs.measurement,
    isUpdatingLocation: model.map.isUpdatingLocation,
    mapMode: model.map.mapMode,
  };
}, actions)(ElevationProfileWidget);
